import { render } from "./NewTeamMemberRowHeader.vue?vue&type=template&id=4fa9aeed&scoped=true"
import script from "./NewTeamMemberRowHeader.vue?vue&type=script&lang=js"
export * from "./NewTeamMemberRowHeader.vue?vue&type=script&lang=js"

import "./NewTeamMemberRowHeader.vue?vue&type=style&index=0&id=4fa9aeed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fa9aeed"

export default script